import React from "react";

function Footer(){
    return(
        <footer>
            <h1>Want to contact me?</h1>
            <div className="contact-info">
                <p>Email: <span>nezam.seraj24@gmail.com</span></p>
                <p>Instagram: <span>nseraj11</span></p>
                <p>LinkedIn: <span>www.linkedin.com/in/nezam-seraj-b317b2240</span></p>
            </div>
        </footer>
    )
}

export default Footer;